import { z } from "zod";
export const linerUsedDtoSchema = z.object({
    linerUsedFromUser: z.string(),
    linerUsedInData: z.string().nullable(),
    dsaUserName: z.string().nullable(),
    timestampUTC: z.string().datetime(),
    robotLDN: z.string(),
    farmLicenseKey: z.string(),
});
//# sourceMappingURL=liner-used.schema.js.map